import CryptoJS from 'crypto-js'

// 生成时间戳
export const generateTimestamp = () => {
  return Date.now().toString()
}

// 生成 token
export const generateToken = (params) => {
  const secret = 'FOS-CODEC-KEY' // 这里需要替换为实际的密钥
  
  // 移除 token 参数
  const { token, ...otherParams } = params
  
  // 按照参数名升序排序
  const sortedParams = Object.keys(otherParams)
    .sort()
    .reduce((acc, key) => {
      acc[key] = otherParams[key]
      return acc
    }, {})
  
  // 拼接参数值并转大写
  const signStr = Object.values(sortedParams)
    .map(value => String(value))
    .join('')
    .toUpperCase()
  
  // 加上密钥后 MD5
  return CryptoJS.MD5(signStr + secret).toString()
}

// 加密密码
export const encryptPassword = (password) => {
  return CryptoJS.MD5(password).toString()
} 